export default "__VITE_ASSET__BUFyLA87__"